module.exports = {
  "AA": "diagnosis",
  "AB": "diagnosis",
  "AC": "diagnosis",
  "AD": "diagnosis",
  "AE": "diagnosis",
  "AF": "diagnosis",
  "AH": "diagnosis",
  "AI": "diagnosis",
  "AM": "diagnosis",
  "AN": "diagnosis",
  "BA": "diagnosis",
  "BY": "diagnosis",
  "DA": "therapeutic",
  "DB": "therapeutic",
  "DC": "therapeutic",
  "DD": "therapeutic",
  "DE": "therapeutic",
  "DG": "therapeutic",
  "DH": "therapeutic",
  "DK": "therapeutic",
  "DL": "therapeutic",
  "DN": "therapeutic",
  "DP": "therapeutic",
  "FA": "therapeutic",
  "FB": "therapeutic",
  "FC": "therapeutic",
  "GA": "therapeutic",
  "JA": "therapeutic",
  "JB": "therapeutic",
  "JC": "therapeutic",
  "JD": "therapeutic",
  "JE": "therapeutic",
  "JF": "therapeutic",
  "JG": "therapeutic",
  "JH": "therapeutic",
  "JI": "therapeutic",
  "JJ": "therapeutic",
  "JK": "therapeutic",
  "JL": "therapeutic",
  "JN": "therapeutic",
  "KA": "therapeutic",
  "KB": "therapeutic",
  "KD": "therapeutic",
  "LA": "therapeutic",
  "LB": "therapeutic",
  "LC": "therapeutic",
  "LD": "therapeutic",
  "LE": "therapeutic",
  "LG": "therapeutic",
  "LH": "therapeutic",
  "LI": "therapeutic",
  "LJ": "therapeutic",
  "LK": "therapeutic",
  "LL": "therapeutic",
  "MA": "therapeutic",
  "MC": "therapeutic",
  "MK": "therapeutic",
  "ML": "therapeutic",
  "PA": "therapeutic",
  "PB": "therapeutic",
  "PC": "therapeutic",
  "PD": "therapeutic",
  "PG": "therapeutic",
  "PH": "therapeutic",
  "PJ": "therapeutic",
  "PM": "therapeutic",
  "PN": "therapeutic",
  "PP": "therapeutic",
  "PQ": "therapeutic",
  "RA": "therapeutic",
  "RB": "therapeutic",
  "RC": "therapeutic",
  "RD": "therapeutic",
  "RE": "therapeutic",
  "RF": "therapeutic",
  "RG": "therapeutic",
  "SB": "therapeutic",
  "SC": "therapeutic",
  "SD": "therapeutic",
  "SE": "therapeutic",
  "SH": "therapeutic",
  "SI": "therapeutic",
  "SJ": "therapeutic",
  "SM": "therapeutic",
  "SN": "therapeutic",
  "SO": "therapeutic",
  "SP": "therapeutic",
  "SQ": "therapeutic",
  "SR": "therapeutic",
  "SY": "therapeutic",
  "TA": "management",
  "TB": "management",
  "TC": "management",
  "TD": "management",
  "TE": "management",
  "TH": "management",
  "TI": "management",
  "TJ": "management",
  "TK": "management",
  "TM": "management",
  "TN": "management",
  "TY": "management",
  "VA": "prevention",
  "VB": "prevention",
  "VC": "prevention",
  "VD": "prevention",
  "VE": "prevention",
  "VF": "prevention",
  "VI": "prevention",
  "VL": "prevention",
  "VN": "prevention",
  "VO": "prevention",
  "VP": "prevention",
  "VR": "prevention",
  "WB": "prevention",
  "WC": "prevention",
  "WD": "prevention",
  "WE": "prevention",
  "WF": "prevention",
  "WG": "prevention",
  "WI": "prevention",
  "WJ": "prevention",
  "WY": "prevention",
  "ZY": "prevention",
  "ZZ": "prevention"
};
